import React from 'react';
import Card from '../common/Card';
import { formatDateTime, getImageUrl } from '../../utils/helpers';

const VersionHistory = ({ versions, currentVersionId }) => {
  return (
    <Card className="p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Version History</h2>
      
      <div className="space-y-4">
        {versions.map((version) => {
          const isCurrent = version.id === currentVersionId;
          
          return (
            <div
              key={version.id}
              className={`p-4 rounded-lg border-2 ${
                isCurrent
                  ? 'border-primary-500 bg-primary-50'
                  : 'border-gray-200 bg-white'
              }`}
            >
              <div className="flex items-start justify-between mb-2">
                <div>
                  <h3 className="font-medium text-gray-900">
                    Version {version.version_number}
                    {isCurrent && (
                      <span className="ml-2 text-xs font-normal text-primary-600">
                        (Current)
                      </span>
                    )}
                  </h3>
                  <p className="text-sm text-gray-600">
                    by {version.created_by_name} • {formatDateTime(version.created_at)}
                  </p>
                </div>
              </div>

              {/* Thumbnail */}
              {version.image_url && (
                <div className="mt-3 mb-2">
                  <img
                    src={getImageUrl(version.image_url)}
                    alt={`Version ${version.version_number}`}
                    className="w-full h-32 object-cover rounded border border-gray-200"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              )}

              {/* Caption Preview */}
              {version.caption && (
                <div className="mt-2">
                  <p className="text-xs text-gray-600 mb-1">Caption:</p>
                  <p className="text-sm text-gray-700 line-clamp-2">{version.caption}</p>
                </div>
              )}

              {/* Notes */}
              {version.notes && (
                <div className="mt-2">
                  <p className="text-xs text-gray-600 mb-1">Notes:</p>
                  <p className="text-sm text-gray-700 line-clamp-2">{version.notes}</p>
                </div>
              )}

              {/* View Full Version Button */}
              {!isCurrent && (
                <button className="mt-3 text-sm text-primary-600 hover:text-primary-700 font-medium">
                  View this version
                </button>
              )}
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default VersionHistory;


